import React from 'react'

type Props = {
  children: React.ReactNode
}

const Submit : React.FC<Props> = ({ children }) => {
  return (
    <div className="form-input-wrapper">
      <button className="button primary default" type="submit">
        {children}
      </button>
    </div>
  )
}

export default Submit
